<template>
  <BulkEmployeeActionModal
    :show="show"
    :employees="employees"
    :loading="loading"
    :results="results"
    :title="TITLE"
    :results-title="RESULTS_TITLE"
    :instruction-text="INSTRUCTION_TEXT"
    :button-text="BUTTON_TEXT"
    :loading-text="LOADING_TEXT"
    :status-labels="STATUS_LABELS"
    :success-statuses="SUCCESS_STATUSES"
    @close="$emit('close')"
    @confirm="$emit('create')"
  />
</template>

<script setup>
import BulkEmployeeActionModal from './BulkEmployeeActionModal.vue';

const TITLE = 'Create Employee Acknowledgement';
const RESULTS_TITLE = 'Acknowledgements Sent';
const INSTRUCTION_TEXT = 'Click "Create Acknowledgement" to send the below employees a link via e-mail '
  + 'to acknowledge the job profile below.';
const BUTTON_TEXT = 'Create Acknowledgements';
const LOADING_TEXT = 'Sending Acknowledgement E-mails...';

const STATUS_LABELS = {
  success: 'Success',
  email_failed: 'Success',
  skipped_pending_status: 'Current Acknowledgement Pending',
  skipped_no_profile: 'Employee Missing Job Profile',
  no_email: 'Employee Missing E-mail Address',
};

const SUCCESS_STATUSES = ['success', 'email_failed'];

defineProps({
  show: { type: Boolean, default: false },
  employees: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  results: { type: Array, default: null },
});

defineEmits(['close', 'create']);
</script>
